import cep from '@/pages/catalog/[...catalog_query]/CatalogExplorerPage.module.scss';
import { Dropdown, Flex, Segmented } from 'antd';
import Image from 'next/image';
import icon_catalog_expandarrow from '/public/static/images/icon_catalog_expandarrow.svg';
import { ECatalogDisplayViewType, ECatalogOrderType, ECatalogSortType } from 'tkmp-lib/src/enums';
import { CatalogGridIcon, CatalogListIcon } from 'tkmp-lib/src/icons/icons';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { usePathname, useSearchParams } from 'next/navigation';
import { ICatalogMenuProps } from 'tkmp-lib/src/interfaces';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import { useStores } from '@/utils/hooks/useStores';
import { observer } from 'mobx-react-lite';

const CatalogActionsHeader = observer(({}: any) => {
    const router = useRouter();
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const LOCALIZATION = useLocalization();

    const {
        systemStore: { CATALOG_DISPLAY_TYPE, setCatalogDisplayType },
    } = useStores();

    const [displayType, setDisplayType] = useState<ECatalogDisplayViewType>(CATALOG_DISPLAY_TYPE);

    //Я переопределил items для breadcrumps чтобы была возможность при смене языка менять значения эти:
    const items: ICatalogMenuProps[] = [
        {
            label: LOCALIZATION.pages.catalog.menuDropdown.popular,
            order: ECatalogOrderType.Desc,
            sort: ECatalogSortType.Popular,
            key: '0',
        },
        {
            label: LOCALIZATION.pages.catalog.menuDropdown.cheap,
            order: ECatalogOrderType.Asc,
            sort: ECatalogSortType.Price,
            key: '1',
        },
        {
            label: LOCALIZATION.pages.catalog.menuDropdown.expensive,
            order: ECatalogOrderType.Desc,
            sort: ECatalogSortType.Price,
            key: '2',
        },
    ];

    // В китайском языке нет алфавита, поэтому фильтр А-Я в китайском будет отсутствовать
    useEffect(() => {
        if (LOCALIZATION.locale != 'cn') {
            items.push(
                {
                    label:
                        LOCALIZATION.locale != 'cn'
                            ? LOCALIZATION.pages.catalog.menuDropdown.nameAZ
                            : '',
                    order: ECatalogOrderType.Desc,
                    sort: ECatalogSortType.Name,
                    key: '3',
                },
                {
                    label:
                        LOCALIZATION.locale != 'cn'
                            ? LOCALIZATION.pages.catalog.menuDropdown.nameZA
                            : '',
                    order: ECatalogOrderType.Asc,
                    sort: ECatalogSortType.Name,
                    key: '4',
                },
            );
        }

        console.log(items);
    }, [LOCALIZATION.locale]);

    // @ts-ignore
    const onClick: ICatalogOnClickDropDown | MenuClickEventHandler = ({ key }) => {
        const value: any = items.find((f) => f.key === key);

        router.push({
            pathname: pathname,
            query: {
                order: value.order,
                sort: value.sort,
            },
        });
    };

    return (
        <Flex
            justify={'space-between'}
            className={cep.dataContainer__header}
        >
            <Dropdown
                className={cep.dataContainer__header_select}
                menu={{
                    // @ts-ignore
                    items,
                    onClick,
                    selectable: true,
                    defaultSelectedKeys: ['0'],
                }}
                trigger={['click']}
            >
                <Flex
                    gap={'4px'}
                    align={'center'}
                    className={`text-16-400`}
                    style={{ color: '#0B0B0C', cursor: 'pointer' }}
                    onClick={(e) => e.preventDefault()}
                >
                    {items.find(
                        (f) =>
                            f.order === searchParams.get('order') &&
                            f.sort === searchParams.get('sort'),
                    )?.label ?? LOCALIZATION.pages.catalog.menuDropdown.popular}
                    <Image
                        src={icon_catalog_expandarrow}
                        alt={''}
                        width={0}
                        height={0}
                        sizes={'100%'}
                    />
                </Flex>
            </Dropdown>
            <Segmented
                className={cep.Segmented}
                defaultValue={displayType}
                onChange={(value) => {
                    setDisplayType(value as ECatalogDisplayViewType);
                    setCatalogDisplayType(value as ECatalogDisplayViewType);
                }}
                options={[
                    {
                        value: ECatalogDisplayViewType.List,
                        label: (
                            <div className={cep.Segmented__element}>
                                <CatalogListIcon
                                    active={
                                        (displayType as ECatalogDisplayViewType) ===
                                        ECatalogDisplayViewType.List
                                    }
                                />
                            </div>
                        ),
                    },
                    {
                        value: ECatalogDisplayViewType.Grid,
                        label: (
                            <div className={cep.Segmented__element}>
                                <CatalogGridIcon
                                    active={
                                        (displayType as ECatalogDisplayViewType) ===
                                        ECatalogDisplayViewType.Grid
                                    }
                                />
                            </div>
                        ),
                    },
                ]}
            />
        </Flex>
    );
});

export default CatalogActionsHeader;
